import { createApp } from './main.js'

const { app, router, store } = createApp()

// If some state from server renderer is present, use it
if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__)
}

router.onReady(() => {
    // this assumes App.vue template root element has `id="app"`
    app.$mount('#app')
})



// WEBPACK FOOTER //
// ./src/entry-client.js